// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"GalleryCarouselSlider_sliderWrapper__fnNrz","video":"GalleryCarouselSlider_video__1vlZ6"};